import { createContext, Dispatch, SetStateAction } from "react";
import { LocationDto } from "./generated/dashboard-client";

interface AppContextProps {
  location: LocationDto;
  setLocation: Dispatch<SetStateAction<LocationDto>>;
}

export const AppContext = createContext<AppContextProps>({
  location: {},
  setLocation() {},
});
